export function appendToUrl(url: string, params: UrlParams): string {
  if (url.includes('?')) {
    if (url.includes('=')) {
      return url + '&' + objectToParamString(params)
    } else {
      return url + objectToParamString(params)
    }
  } else {
    return url + '?' + objectToParamString(params)
  }
}

export type UrlQueryParameterValue = string | number | Date | boolean
export type UrlParams = {
  [key: string]: UrlQueryParameterValue
}

const objectToParamString = (obj: UrlParams) => {
  return Object.keys(obj)
    .filter(key => obj[key] !== '')
    .map(key => key + '=' + obj[key])
    .join('&')
}
